const DarkMode = {
    backgroundColor: "#070707",
};

export default DarkMode
